<template>
  <div>
    <verify-form
      :transaction.sync="transaction"
      :is-showing.sync="isShowingStartForm"
      @verified="handleTransactionVerified"
    ></verify-form>

    <v-dialog v-model="isUpdating" title="Update a transaction" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Update Crypto Transaction</span>
          <v-btn text icon dark @click="isUpdating = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <update-transaction-form
            method="put"
            :transaction="transaction"
            :user="[transaction.user]"
            @transactionUpdated="transactionUpdated"
          />
        </v-container>
      </v-card>
    </v-dialog>

    <v-card v-if="transaction">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Crypto details
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <strong>Address: {{ transaction.address || "N/A" }}</strong>

        <v-spacer></v-spacer>

        <v-btn color="primary" tile @click="isUpdating = true" :disabled="completing">
          <v-icon>mdi-update</v-icon>
          Update Transaction
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          :disabled="transaction.crypto_sending_status === 'completed' || completing"
          :loading="completing"
          @click="completeTransaction"
        >
          <v-icon>
            mdi-progress-upload
          </v-icon>
          Complete Transaction
        </v-btn>
      </v-toolbar>

      <!-- coinbase account info -->
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2" class="d-flex align-center">
            <h2 class="subtitle-2 text-uppercase">Remaing Balance</h2>
          </v-col>
          <v-col cols="12" md="4" v-for="(balance, index) in coinbaseBal" :key="index">
            <span class="font-weight-bold primary--text display-1">
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: balance.currency,
                }).format(balance.balance)
              }}</span
            >
          </v-col>
          <v-col cols="12" md="2">
            <!-- just for spacing ;) -->
          </v-col>
        </v-row>
      </v-card-text>

      <!-- info -->
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <h2 class="subtitle-2 text-uppercase">Info</h2>
          </v-col>
          <v-col cols="12" md="3">
            <key-value title="Id" :value="transactionKey('id')" type="none" />
          </v-col>

          <v-col cols="12" md="2">
            <key-value title="Crypto Country">
              <span>
                {{ transactionKey("crypto_country.name") }}
              </span>
            </key-value>
          </v-col>

          <v-col cols="12" md="1">
            <key-value title="Status">
              <v-icon
                color="success"
                size="40"
                v-if="transaction.crypto_sending_status === 'completed'"
                >mdi-progress-check</v-icon
              >
              <v-icon
                color="error"
                size="40"
                v-else-if="transaction.crypto_sending_status === 'failed'"
                >mdi-progress-close</v-icon
              >
              <v-icon color="warning" size="40" v-else>mdi-progress-alert</v-icon>
            </key-value>
          </v-col>

          <v-col cols="12" md="2">
            <key-value title="Local Ammount">
              <span v-if="transaction.local_amount">
                <span class="font-weight-bold primary--text title">
                  {{ transactionKey("local_amount") | currency }}</span
                >
                {{ transactionKey("local_currency.short_name") }}
              </span>
            </key-value>
          </v-col>

          <v-col cols="12" md="2">
            <key-value title="Crypto Value">
              <span v-if="transaction.value">
                <span class="font-weight-bold primary--text display-1">
                  {{ transactionKey("value") | crypto }}
                </span>
                {{ transactionKey("crypto_currency.short_name") }}
              </span>
            </key-value>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- currencies -->
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <h2 class="subtitle-2 text-uppercase">Currencies</h2>
          </v-col>
          <v-col cols="12" md="3">
            <key-value title="Crypto Currency" :value="transactionKey('crypto_currency.name')">
            </key-value>
          </v-col>
          <v-col cols="12" md="3">
            <key-value
              title="Reference Currency"
              :value="transactionKey('reference_currency.name')"
            >
            </key-value>
          </v-col>

          <v-col cols="12" md="4">
            <key-value title="Local Currency" :value="transactionKey('local_currency.name')">
            </key-value>
          </v-col>
        </v-row>
      </v-card-text>
      <!--dates-->
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <h2 class="subtitle-2 text-uppercase">Dates</h2>
          </v-col>
          <v-col cols="12" md="3">
            <key-value title="Created At" :value="transaction.created_at" type="date" />
          </v-col>
          <!-- <v-col cols="12" md="3">
            <key-value title="Started At" :value="transaction.started_at" type="date" />
          </v-col> -->
          <v-col cols="12" md="4">
            <key-value title="Started At" :value="transaction.verified_at" type="date" />
          </v-col>
        </v-row>
      </v-card-text>

      <!--Rates-->
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <h2 class="subtitle-2 text-uppercase">Rates</h2>
          </v-col>
          <v-col cols="12" md="3">
            <show-rate
              title="Initialization Stage"
              from="reference_currency"
              to="local_currency"
              rate-key="reference_to_local_rate_at_init"
              :transaction="transaction"
            />
          </v-col>
          <v-col cols="12" md="3">
            <show-rate
              title="Start Stage"
              from="reference_currency"
              to="local_currency"
              rate-key="reference_to_local_rate_at_start"
              :transaction="transaction"
            />
          </v-col>

          <v-col cols="12" md="4">
            <show-rate
              title="Verification(Applied Rate)"
              from="crypto_currency"
              to="reference_currency"
              rate-key="reference_to_crypto_rate_at_verify"
              :transaction="transaction"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import verifyForm from "./verifyForm";
import ShowRate from "./showRate";
import UpdateTransactionForm from "../cryptoTransactionForm";
import CoinbaseBalance from "../fetchCoinbaseBalance";

export default {
  components: {
    verifyForm,
    ShowRate,
    UpdateTransactionForm,
  },
  props: {
    dataTransaction: {
      required: true,
    },
  },
  mixins: [CoinbaseBalance],
  data() {
    return {
      transaction: this.dataTransaction,
      isShowingStartForm: false,
      completing: false,
      isUpdating: false,
    };
  },
  created() {
    //this.getCoinbaseBal();
  },
  methods: {
    transactionKey(key, defaultValue = null) {
      return this.extractDataKey(this.transaction, key, defaultValue);
    },
    handleTransactionVerified({ transaction }) {
      this.transaction = transaction;
      this.isShowingStartForm = false;
      Notify.success("Transaction was verified successfully");
    },
    transactionUpdated({ message, transaction }) {
      // eslint-disable-next-line no-console
      this.isUpdating = false;
      window.Notify.success(message);
      this.transaction = transaction;
      this.$emit("userUpdated", transaction.user);
    },
    completeTransaction() {
      this.completing = true;
      const url = "api/v1/cryptoPayments";
      // initiate transaction
      return this.$http
        .post(url, { transaction_id: this.transaction.id })
        .then((response) => {
          this.completing = false;
          window.Notify.success(response.message);
          this.$router.push({ name: "crypto.transactions" });
        })
        .catch((error) => {
          this.completing = false;
          Notify.errorFromResponse(error, { close: true });
        });
    },
  },
};
</script>
